import * as React from 'react'
import { Link } from 'gatsby'
import { cls } from '../../../../utils/utils'
import SimpleMarkdown from '../../../SimpleMarkdown/SimpleMarkdown'
import Image from '../../../Image/Image'
import Tags from '../../../Tags/Tags'
import * as styles from './PagePreviewTiles.module.scss'
import { IPagePreviewItem } from './PagePreviewTiles.types'

export const PagePreviewTile: React.FC<IPagePreviewItem> = ({ content, defaultTileImage, root, saveState }) => (
  <div className={styles.scalable}>
    <article key={content.id} className={styles.tileContainer}>
      <Link
        to={content.fields.slug}
        className={styles.item}
        onClick={() => {
          if (saveState) {
            localStorage.setItem('scrollState', JSON.stringify({ scrollPosition: window.scrollY }))
          }
        }}
      >
        <div className={styles.imageContainer}>
          {content.frontmatter.previewImage ? (
            <Image image={content.frontmatter.previewImage.publicURL} className={styles.image} />
          ) : (
            <Image image={defaultTileImage} className={styles.image} />
          )}
        </div>
        <div className={styles.mainText}>
          {content.frontmatter.date && <small className={cls('text--caption', styles.date)}>{content.frontmatter.date}</small>}
          <h3 className={styles.newsTitle}>{content.frontmatter.title}</h3>
          {content.frontmatter.summary && <SimpleMarkdown body={content.frontmatter.summary} className={cls(styles.summary)} />}
          {content.frontmatter.tags && <Tags tags={content.frontmatter.tags} root={root} />}
        </div>
      </Link>
    </article>
  </div>
)
